<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'

// Component Imports
import Button from '@/common/Button.vue'

// Define Props
const props = defineProps({
    viewId: String
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Computed Properties
const page = computed(() => viewStore.page || 1)

const isDisabled = computed(() => page.value === 1)

// Methods
const onClick = () => {
    if (page.value > 1) {
        viewStore.pageDown()
    }
}
</script>

<template>
    <Button :disabled="isDisabled" class="rounded-0" @click="onClick">
        <i class="bi-chevron-left"/>
    </Button>
</template>